import * as React from 'react';
import { observer } from 'mobx-react';
import './summaryDashboardCard.scss';

export interface IStatusSummaryButtonProps {
    statusSummary: IStatusSummary;
    managerViewId?: number;
}

export class StatusSummaryButton extends React.Component<IStatusSummaryButtonProps> {
    constructor(props: IStatusSummaryButtonProps) {
        super(props);
    }

    render(): React.ReactNode {
        const { statusSummary } = this.props;
        const numberClass = statusSummary.statusCount === 0 ? 'num-zero' : '';
        const classes = `num ${numberClass} default-cursor`;
        return (
            <span
                className={`status-summary-button ${classes}`}
            >
                {statusSummary.statusCount}
            </span>
        );
    }
}

export default observer(StatusSummaryButton);